const Footer = () => {
  return (
    <footer className="footer__container">
      <div className="footer__description">
        Living, learning, and leveling up
        <div></div>
        one day at a time.
      </div>
      <div className="footer__copyright">
        © {new Date().getFullYear()} All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
